module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.7.3-260.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/changelog/v2.7.3.md
// module id = 704
// module chunks = 246